import cn from 'classnames';
import { WEB_BLUETOOTH_SAMPLES_LINK } from '../../constants';
import { LinkIcon } from '../../icons';
import styles from './CustomLink.module.scss';

export default function CustomLink({ className = '', href = '', text = '' }) {
  return (
    <a
      href={WEB_BLUETOOTH_SAMPLES_LINK}
      target="_blank"
      rel="noreferrer"
      className={cn(styles.customLink, className)}
    >
      <div className={styles.customLinkContent}>
        <LinkIcon className={styles.customLinkIcon} />
        {text}
      </div>
    </a>
  );
}
